import { Injectable } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { BehaviorSubject, first, Observable } from 'rxjs';
import { apiCallWrapper } from '../api/api.util';
import { IQueryFilter, QueryResult } from '../model/query.filter.class';
import { HasId } from '../model/generics';
import { Brand } from '../model/ddb.model';
import { BrandApi } from '../api/brand.api';
import { LoadingService } from './core/loading.service';
import { SubscriptionGroup } from '../util/subscriptionGroup';
import { logger } from '../util/Logger';

const className = 'BrandService'

@Injectable()
export class BrandService {
  public readonly allBrands$ = new BehaviorSubject(
    new QueryResult<Brand & HasId<string>>()
  );
  constructor(
    private notifications: NotificationsService,
    private brandApi: BrandApi,
    private loadingService: LoadingService
  ) {
    this.refreshBrandCache()
  }

  public refreshBrandCache() {
    const signature = className + ".refreshBrandCache: ";
    this.brandApi
      .getUnauthBrands(
    )
      .pipe(first())
      .subscribe({
        next: (val) => {
          logger.silly(signature + `Refreshed Brand Cache`);
          this.allBrands$.next(
            val instanceof QueryResult ? val : new QueryResult(val)
          );
        },
      });
  }


  public list(query: IQueryFilter): Observable<QueryResult<Brand & HasId<string>>> {
    return apiCallWrapper(
      this.brandApi.list(query),
      {
        notificationsService: this.notifications,
        action: "Fetching Brand"
      }
    )
  }

  public get(id: string): Observable<Brand & HasId<string>> {
    return this.brandApi.getBrandDetail(id)
  }


  public create(data: any): Observable<Brand & HasId<string>> {
    return apiCallWrapper(
      this.loadingService.blockWithLoadingOverlayRx(
        this.brandApi.create(data)
      ),
      {
        notificationsService: this.notifications,
        action: "Saving Brands"
      }
    )
  }

  // public getUnauthBrands(): Observable<QueryResult<Brand & HasId<string>>> {
  //   return this.brandApi.getUnauthBrands()
  // }

  public restore(id: number | string) {
    return apiCallWrapper(
      this.loadingService.blockWithLoadingOverlayRx(this.brandApi.restore(id)),
      {
        notificationsService: this.notifications,
        action: "Restore Brand",
      },
    );
  }
}
